import React, {memo} from 'react';
import '../css/TopNav.css';
import { Navbar } from 'reactstrap';
import { Link } from 'react-router-dom';
import logo from '../flying-t.png';
import { useFilterDispatch } from '../contexts/FilterContextProvider';
import SkipLink from './SkipLink';

function TopNav() {
  const filterDispatch = useFilterDispatch();
  const navClick = (e) => {
    //e.preventDefault();
    filterDispatch({
      type: "page",
      payload: "home"
    });
  };

  return (
      <>
        <SkipLink />
        <Navbar id="top-nav" expand="lg" className={"desktop-mb-3"} aria-label="Site Header">
          <Link to="/" className="navbar-brand" onClick={(e) => navClick(e)}><img alt="ODOT Flying T Logo" src={logo} /><h1>Transportation Project Tracker</h1></Link>
        </Navbar>
      </>
  )
}

export default memo(TopNav);